import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useUpdateChargerMutation, useGetAllBrandsQuery, useGetAllStoragesQuery, useGetAllColorsQuery, useGetAllGroupsQuery, useGetAllMaterialsQuery, useGetAllModelsQuery, useAddGroupMutation } from '../../../../features/fullApi';
import { basicSchema } from "./validation";
import { useTheme } from '@mui/material/styles';
import { Store } from 'react-notifications-component';
import { toast } from 'react-hot-toast';

const EditCharger = () => {
  
  window.scrollTo(0,0)
  const params = useParams()
  const [charger, setCharger] = useState({})
  const user = JSON.parse(localStorage.getItem('user'))

  const [reqDone, setReqDone] = useState(false)
  const [type, setType] = React.useState('');
  const [power, setPower] = React.useState('');
  const [brand, setBrand] = useState("");
  const [color, setColor] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const {data: brands, error: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()



  useEffect(() => {
    const getCharger = async () => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/chargers/find/${params.id}`)
      .then(res => {
        setCharger(res.data)
        setReqDone(true)
        console.log("charger", charger)
      })
      .catch(err => console.log(err))
    }
    getCharger()
  }, [])


  const [getCallColor, setCallGetColor] = useState(false)
  const [getCallBrand, setCallGetBrand] = useState(false)


 useEffect(() => {
  const getBrand = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${charger.brandId}`)
    .then(res => {
      console.log("res.data", res.data)
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  }
  getBrand()
}, [reqDone])

useEffect(() => {
  setPower(charger?.power)
  setType(charger?.type)
}, [reqDone])


useEffect(() => {
  const getColor = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${charger.colorId}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  }
  getColor()
}, [reqDone])


  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  const handleBrand = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${event.target.value}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleColor = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${event.target.value}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleChangePower = (event) => {
    setPower(event.target.value);
  };

  const handleChangeType = (event) => {
    setType(event.target.value);
  };

useEffect(() => {
      const fields = ['desc', 'img', 'brandId','quantity', 'colorId','price', 'power', 'type'];
      fields.forEach(field => setFieldValue(field, charger[field], false));
}, [charger]);

const [chargerImgLink, setChargerImgLink] = useState(charger.img)
const uploadImage = async () => {
  const formData = new FormData()
  formData.append("file", selectedFile)
  formData.append("upload_preset", "zt8iigue")
  const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
  .then(res => {
    setChargerImgLink(res.data.secure_url)
  })
};

//constructing the boolean colors checked array
const [groupsObj, setGroupsObj] = useState({})
  
        useEffect(() => {
          if(!isLoadingGroups) {
            console.log("GROUPS#####", groups)
            Object.keys(groups).forEach(ele => {
              let key = groups[ele].groupName
                groupsObj[key] = groups[ele]._id;
            });
          }
}, [groups, isLoadingGroups])

const [addGroup] = useAddGroupMutation()
const [updateCharger] = useUpdateChargerMutation()

const onSubmit = async(values, actions) => {

  if(groupsObj[brand.brandName + " " + type + " " + power]?.length>0) {
    updateCharger({_id: charger._id, title: "Charger " + brand.brandName + " " + color.colorName + " " + type + " " + power, desc: values.desc, power: power, type: type, groupId: groupsObj[brand.brandName + " " + type + " " + power], brandId: brand._id, colorId: color._id,  price: values.price, quantity: values.quantity, img: chargerImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`${"Charger " + brand.brandName + " " + type + " " + power} successfully created`)
    })
    .catch((e) => {
      toast("Charger already exists")
    })
} else {
  addGroup({groupName: brand.brandName + " " + type + " " + power })
  .then(res => {
    updateCharger({_id: charger._id, title: "Charger " + brand.brandName + " " + color.colorName + " " + type + " " + power, desc: values.desc,  power: power, type: type, groupId: res.data._id, brandId: brand._id, colorId: color._id, price: values.price, quantity: values.quantity, img: chargerImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`${"Charger " + brand.brandName + " " + color.colorName } successfully created`)
    })
    .catch((e) => {
      toast("Charger already exists")
      console.log("e is", e)
    })
  })
  .catch(err => {
    console.log("error when creating new group")
  })
}
navigate('/chargers/1')
}

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      desc: charger?.desc,
      img: charger?.img,
      brand: charger?.brandId,
      color: charger?.colorId,
      price: charger?.price,
      power: charger?.power,
      type: charger?.type,
      quantity: charger?.quantity
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    uploadImage()
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  console.log("COLOR IS", color)
  console.log("BRAND IS", brand)

  const renderMobileEditCharger = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>

    {(charger && color && brand) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <h3 className="center">Edit {charger.title}</h3>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="desc"
          type="text"
          margin="dense"
          value={values.desc}
          onChange={handleChange}
          onBlur={handleBlur}
          focused
          label={"Desc"}
          sx={{
            "& .MuiInputBase-root": {
                height: 40
          }}}
        />
      </FormControl>
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={chargerImgLink ? chargerImgLink : charger.img} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>     
      </div>
      <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>


        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>



      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <InputLabel>Power</InputLabel>
        <Select
          id="power"
          value={power}
          label="Power"
          onChange={handleChangePower}
        >
          <MenuItem value="25W">25W</MenuItem>
          <MenuItem value="15W">15W</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <InputLabel>Type</InputLabel>
        <Select
          id="type"
          value={type}
          label="Type"
          onChange={handleChangeType}
        >
          <MenuItem value="USB-A">USB-A</MenuItem>
          <MenuItem value="USB-C">USB-C</MenuItem>
          <MenuItem value="MicroUSB">MicroUSB</MenuItem>
          <MenuItem value="USB - Multi Port">USB - Multi Port</MenuItem>
          <MenuItem value="Wireless">Wireless</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
          size="small"
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
        size="small"
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {charger?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a charger image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderTabletEditCharger = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(charger) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <Typography variant="h6" className="center">Edit Charger {charger.title}</Typography>
      <TextField
        id="title"
        type="text"
        value={values.title}    
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.title ? "" : "Title"}
        margin="dense"
      />
      {errors.title && touched.title && <p className="error">{errors.title}</p>}

      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.desc ? "" : "Desc"}
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <Image cloudName="deqqgmfxk"  publicId={chargerImgLink ? chargerImgLink : charger.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      <Stack style={{marginBottom:'20px'}}>
        <Button variant="contained" color="secondary" component="label" style={{marginBottom: '10px'}}>
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button variant="contained" size="small" style={{width: '250px'}} onClick={() => uploadImage()}>Save Image</Button>
      </Stack>


      <FormControl fullWidth>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.price ? "" : "Price"}
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {charger?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a charger image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderDesktopEditCharger = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(charger && color && brand) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
    <Typography style={{marginTop:'64px', marginBottom:'10px'}} variant="h5" className="center">Edit Charger {charger.title}</Typography> 

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Desc"}
        multiline
        rows={5}
        focused
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}
      </FormControl>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={chargerImgLink ? chargerImgLink : charger.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      </div>
      <Stack direction="row" justifyContent="space-between" style={{marginBottom:'15px', marginTop:'15px'}}>
        <Button size="medium" sx={{width: '150px'}} variant="contained" color="secondary"  component="label">
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button size="medium" variant="contained"  sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>



      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <InputLabel>Power</InputLabel>
        <Select
          id="power"
          value={power}
          label="Power"
          onChange={handleChangePower}
        >
          <MenuItem value="25W">25W</MenuItem>
          <MenuItem value="15W">15W</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <InputLabel>Type</InputLabel>
        <Select
          id="type"
          value={type}
          label="Type"
          onChange={handleChangeType}
        >
          <MenuItem value="USB-A">USB-A</MenuItem>
          <MenuItem value="USB-C">USB-C</MenuItem>
          <MenuItem value="MicroUSB">MicroUSB</MenuItem>
          <MenuItem value="USB - Multi Port">USB - Multi Port</MenuItem>
          <MenuItem value="Wireless">Wireless</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>
      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {charger?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a charger image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/chargers/page=1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileEditCharger() : 
        (isSm) ? renderMobileEditCharger() :
        (isMd) ? renderMobileEditCharger() :
        renderDesktopEditCharger()
      }
    </div>
  );
}

export default EditCharger